<template>
  <div>
    <!--blog Section start-->
    <div class="page-margin">
      <!-- blog Section starts -->
      <section>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="blog-item">
                <div class="blog-block">
                  <div class="blog-box">
                    <div class="overflow-hidden">
                      <a href="#">
                        <img
                          src="../assets/images/blog/blog-details.jpg"
                          alt="blog"
                          class="img-fluid"
                        >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="blog-text">
                  <h6>25 january 2018</h6>
                  <a href="#">
                    <h3 class="blog-head">See How ezFix'd Saves You Money</h3>
                  </a>
                  <div class="blog-divider" />
                  <div class="blog-description">
                    <iframe
                      width="560"
                      height="315"
                      src="https://www.youtube.com/embed/iyldfrldDr0"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    />
                    <p>
                      Car Care Council Introduces New Video for Fall Car Care Month in October
                      A new video from the Car Care Council, entitled “Auto Care Goes a Long Way,” shows how vehicle owners can save money with some simple preventative maintenance.

                      A little auto care can go a long way toward protecting your vehicle investment. Neglecting your vehicle can be very costly in the form of more expensive repairs and loss of resale value down the road. This new video highlights easy ways to keep your vehicle running efficiently and safely.

                      Introduced for Fall Car Care Month in October, the new video illustrates how addressing certain items like brakes, tires, belts and hoses and fluids, including oil, antifreeze, steering, brake, transmission and wiper fluids, will help keep your car running smoothly and efficiently, saving money at the gas pump. Other areas of the vehicle, such as heating and air conditioning systems, wipers and lights, should also be checked periodically.
                    </p>
                    <h5>Mark jkcno</h5><h5 class="pull-right">
                      10 <i class="fa fa-heart-o" />, 50 <i class="fa fa-comments-o" />
                    </h5>
                  </div>
                </div>
              </div>
              <div class="blog-divider" />
              <div class="row">
                <div class="col-md-10 offset-md-1 leave-coment">
                  <h3 class="text-center">
                    Leave Your Comment
                  </h3>
                  <form class="theme-form footer-form p-0 mt-3">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-lg-6 col-md-12 md-fgrup-margin">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="your name"
                          >
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <input
                            id="exampleFormControlInput1"
                            type="email"
                            class="form-control"
                            placeholder="email address"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <textarea
                        id="exampleFormControlTextarea1"
                        class="form-control"
                        rows="4"
                        placeholder="message"
                      />
                    </div>
                    <div class="form-button">
                      <button
                        type="submit"
                        class="btn btn-custom theme-color"
                      >
                        send
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--blog Section End-->

      <!--Footer Section start-->
      <js />
      <!--Footer Section End-->
    </div>
    <!--blog Section end -->
  </div>
</template>
<script>
export default {
  name: 'BlogDetails',
}
</script>



// WEBPACK FOOTER //
// src/blog/blog_details.vue